
import {
    CREATE_DIRECT_BILLING_DETAILS_FAILURE,
    CREATE_DIRECT_BILLING_DETAILS_MASTER_USERFORM,
    CREATE_DIRECT_BILLING_DETAILS_REQUEST,
    CREATE_DIRECT_BILLING_DETAILS_SUCCESS,
    DELETE_DIRECT_BILLING_DETAILS_DATA_FAILURE,
    DELETE_DIRECT_BILLING_DETAILS_DATA_REQUEST,
    DELETE_DIRECT_BILLING_DETAILS_DATA_SUCCESS,
    DIRECT_BILLING_DETAILS_RESET_USERFORM,
    FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_FAILURE,
    FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_REQUEST,
    FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_SUCCESS,
    FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_FAILURE,
    FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_REQUEST,
    FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_SUCCESS,
    UPDATE_DIRECT_BILLING_DETAILS_FAILURE,
    UPDATE_DIRECT_BILLING_DETAILS_REQUEST,
    UPDATE_DIRECT_BILLING_DETAILS_SUCCESS
} from "./directBillingDetails.actionType";


export const DIRECT_BILLING_DETAILS = 'directBillingDetails';

let initialState = {
    loading: false,
    DirectBillingDetailsData: [],
    DBDetailsForm: {
        fldQuantity: 0,
        fldRate: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldGSTConcept: 'FCM',
    },
};

export let directBillingDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_REQUEST:
        case FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_REQUEST:
        case UPDATE_DIRECT_BILLING_DETAILS_REQUEST:
        case DELETE_DIRECT_BILLING_DETAILS_DATA_REQUEST:
        case CREATE_DIRECT_BILLING_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case CREATE_DIRECT_BILLING_DETAILS_MASTER_USERFORM:
            return {
                ...state,
                loading: false,
                DBDetailsForm: {
                    ...state.DBDetailsForm,
                    [payload.key]: payload.value
                }
            }
        case FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                DirectBillingDetailsData: updatePayload,
            };
        case FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                DBDetailsForm: updatePayload
            }
        case CREATE_DIRECT_BILLING_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                DBDetailsForm: {
                    fldQuantity: 0,
                    fldRate: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldGSTConcept: 'FCM',
                }
            }
        case UPDATE_DIRECT_BILLING_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                DBDetailsForm: {
                    fldQuantity: 0,
                    fldRate: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldGSTConcept: 'FCM',
                }
            }

        case DELETE_DIRECT_BILLING_DETAILS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                DBDetailsForm: {
                    fldQuantity: 0,
                    fldRate: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldGSTConcept: 'FCM',
                }
            }

        case DIRECT_BILLING_DETAILS_RESET_USERFORM:
            return {
                ...state,
                loading: false,
                DBDetailsForm: {
                    fldQuantity: 0,
                    fldRate: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldGSTConcept: 'FCM',
                }
            }
        case FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_FAILURE:
        case FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_FAILURE:
        case UPDATE_DIRECT_BILLING_DETAILS_FAILURE:
        case DELETE_DIRECT_BILLING_DETAILS_DATA_FAILURE:
        case CREATE_DIRECT_BILLING_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state

    }
}